import useThrottledCallback from 'beautiful-react-hooks/useThrottledCallback';
import useWindowResize from 'beautiful-react-hooks/useWindowResize';
import { useMemo, useState } from 'react';

export const useWindowSize = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [orientation, setOrientation] = useState(screen.orientation?.type);
  const onWindowResize = useWindowResize();

  onWindowResize(
    useThrottledCallback(() => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      setOrientation(screen.orientation?.type);
    }),
  );

  return useMemo(() => ({ width, height, orientation }), [width, height, orientation]);
};
